import { insertTrackEvent } from '@comeon/analytics';

export enum FlowType {
	'popup' = 'Pop up',
	'account' = 'Account'
}
export type SpendingLimitEventType = { label: string; flow?: FlowType };

const category = 'Spending Limits';

export const trackSpendingLimitEvent = ({ label, flow = FlowType.popup }: SpendingLimitEventType) => {
	const action = `${flow} flow`;
	insertTrackEvent({ category, action, label });
};

export const spendingLimitStoragekey = 'spending.limit.flow';
